import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ProfitAuthProvider, useProfitAuthState } from "../auth/ProfitAuthContext";
import ProfitLayout from "../layout/ProfitLayout";
import ProfitLoginPage from "../pages/ProfitLoginPage";
import "../styles/profit.css";

export function ProfitPrivateRoute({ component, ...rest }) {
  const isAuthenticated = useProfitAuthState();

  return (
    <Route
      {...rest}
      render={function renderPrivateRoute(props) {
        return isAuthenticated ? (
          React.createElement(component, props)
        ) : (
          <Redirect
            to={{
              pathname: "/profit/login",
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
}

export function ProfitPublicRoute({ component, ...rest }) {
  const isAuthenticated = useProfitAuthState();

  return (
    <Route
      {...rest}
      render={function renderPublicRoute(props) {
        return isAuthenticated ? (
          <Redirect to="/profit/dashboard" />
        ) : (
          React.createElement(component, props)
        );
      }}
    />
  );
}

function ProfitRouteSwitch() {
  const isAuthenticated = useProfitAuthState();

  return (
    <Switch>
      <Route
        exact
        path="/profit"
        render={function renderRoot() {
          return <Redirect to={isAuthenticated ? "/profit/dashboard" : "/profit/login"} />;
        }}
      />
      <ProfitPublicRoute exact path="/profit/login" component={ProfitLoginPage} />
      <ProfitPrivateRoute path="/profit" component={ProfitLayout} />
    </Switch>
  );
}

export default function ProfitRoutes() {
  return (
    <ProfitAuthProvider>
      <ProfitRouteSwitch />
    </ProfitAuthProvider>
  );
}
